export default {
  name: 'SipColumn',
  props: {
    className: {
      type: String
    },
    col: {
      type: String
    },
    text: {
      type: String
    }
  },
  methods: {
    prepare() {
      let text = this.text
      // text = text.replace(/[0-9] /ig, '&nbsp;')
      // text = text.replace(/— /ig, '—&nbsp;')
      return text
    }
  },
  computed: {
    cName () {
      let className = ''
      if(this.className) {
        className += `${this.className} `
      }
      if(this.col) {
        className += `sip_col sip_col_${this.col} `
      }
      return className
    }
  },
  render: function (h) {
    console.log(this.col)
    return h('div',
      {
        attrs: {
          class: this.cName
        },
        domProps: {
          innerHTML: this.prepare()
        },
        on: this.$listeners,
      }, this.$slots.default)
  }
}